const STORAGE_PREFIX = 'egabinet-desktop:';

export type PreferenceStorageKey<STORAGE_KEY extends string> = `${typeof STORAGE_PREFIX}${STORAGE_KEY}`;

export const getPreferencesStorageKey = <STORAGE_KEY extends string>(
   storageKey: STORAGE_KEY
): PreferenceStorageKey<STORAGE_KEY> => `${STORAGE_PREFIX}${storageKey}`;
